import { createSlice } from '@reduxjs/toolkit'
import { ADD } from '../../utils/Constants'

export const ProgKeysReducer = createSlice({
    name: 'progkeys',
    initialState: {

        //Prog-keys profiles
        progKeysProfTableSchema: [],
        progKeysProfTableList: null,
        progKeysProfFilteredList: [],
        progKeysSumDetailSchema: [],

        //Prog-keys modal
        progKeysSchema: {},
        progKeysFuncSchema: {},
        progKeysData: {},
        progKeysCurrData: {},
        progKeysInstruction: "",
        pkActionMode: ADD,
        pkParentActionMode: ADD,
        pkCurrFuncAttrs: {},
        pkBaseCurrFuncAttrs: {}
    },
    reducers: {
        setProgKeysProfTableSchema: (state, action) => {
            state.progKeysProfTableSchema = action.payload
        },
        setProgKeysProfTableList: (state, action) => {
            state.progKeysProfTableList = action.payload
            state.progKeysProfFilteredList = action.payload
        },
        setProgKeysProfFilteredList: (state, action) => {
            state.progKeysProfFilteredList = action.payload
        },
        setProgKeysSumDetailSchema: (state, action) => {
            state.progKeysSumDetailSchema = action.payload
        },
        setProgKeysSchema: (state, action) => {
            state.progKeysSchema = action.payload
        },
        setProgKeysData: (state, action) => {
            state.progKeysData = action.payload
            state.progKeysCurrData = action.payload
        },
        setProgKeysCurrData: (state, action) => {
            state.progKeysCurrData = action.payload
        },
        setProgKeysFuncSchema: (state, action) => {
            state.progKeysFuncSchema = action.payload
        },
        setProgKeysInstruction: (state, action) => {
            state.progKeysInstruction = action.payload
        },
        setPkActionMode: (state, action) => {
            // state.pkParentActionMode = action.payload === ADD ? "" : state.pkActionMode
            state.pkActionMode = action.payload
        },
        setPKParentActionMode: (state, action) => {
            state.pkParentActionMode = action.payload
            state.pkActionMode = action.payload
        },
        setPkCurrFuncAttrs: (state, action) => {
            state.pkCurrFuncAttrs = action.payload
        },
        setPkBaseCurrFuncAttrs: (state, action) => {
            state.pkBaseCurrFuncAttrs = action.payload
        }
    },
})

// Action creators are generated for each case reducer function
export const { setProgKeysProfTableSchema, setProgKeysProfTableList, setProgKeysSumDetailSchema, setProgKeysProfFilteredList,
    setProgKeysSchema, setProgKeysData, setProgKeysCurrData, setProgKeysFuncSchema, setProgKeysInstruction, setPkActionMode,
    setPKParentActionMode, setPkCurrFuncAttrs, setPkBaseCurrFuncAttrs } = ProgKeysReducer.actions

export default ProgKeysReducer.reducer